import { useRouter } from "next/router";

import ButtonV2 from "@/components/shared/buttonV2";
import Modal from "@/components/shared/modal";

type Props = {
  errFileExt: string;
  showErrorModal: boolean;
  setShowErrorModal: React.Dispatch<React.SetStateAction<boolean>>;
};

/* 写真がpng,jpg,jpeg以外の場合のエラー表示 */
const FileExtErrorModal: React.FC<Props> = ({
  errFileExt,
  showErrorModal,
  setShowErrorModal
}) => {
  const router = useRouter();

  return (
    <Modal
      show={showErrorModal}
      showClose={true}
      title="対応外のファイル形式です"
      titleRed={true}
      setShow={setShowErrorModal}
    >
      <div className="m-24 mt-0">
        <div className="text-md font-normal">
          <div>
            <p>
              選択された写真のファイル形式（{errFileExt}
              ）はCOSOJIでは対応していない為、アップロードが正常に行えない可能性があります。
            </p>
            <p>大変お手数ですが、カメラの設定をご確認ください。</p>
            <p className="mt-24">対応ファイル形式：png, jpg, jpeg</p>
          </div>
          <div className="mt-4 text-sm">
            <p>
              ※写真が正常にアップロードできた場合は、このエラーは無視してください。
            </p>
            <p>
              ※このエラーが解消しない場合は、スクリーンショットをCOSOJI事務局へ送付願います。
            </p>
          </div>
        </div>

        <div className="mt-8 text-center">
          <ButtonV2
            variant="primary"
            layout="fullWidth"
            click={() => {
              setShowErrorModal(false);
              router.reload();
            }}
          >
            閉じる（再読み込みをします）
          </ButtonV2>
        </div>
      </div>
    </Modal>
  );
};

export default FileExtErrorModal;
